import setupMessages from './setup-messages';

export default {
  setupMessages,
};
